import React from "react";
import { number, func } from "prop-types";
import { WithFacebookLogin } from "@quintype/components";

import { getUser } from "../../utils/api";
import { setAccessTypeUser, getUserSubscriptions } from "../../helper/access-type";

import SocialAuthButton from "../social-auth-button";

const FacebookAuth = ({ facebookId, setMember, setLoading, closePopup, setUserPlans }) => {
  const socialLogin = (e, login) => {
    e.preventDefault();

    setLoading(true);

    login()
      .then(() => {
        // Fetch the user details
        getUser()
          .then(result => {
            setMember(result.user);

            closePopup && closePopup();
            const { user } = result;

            setAccessTypeUser(user.email, user["phone-number"], user.id, user.name).then(() => {
              getUserSubscriptions().then(data => {
                setUserPlans(data.subscriptions);

                setLoading(false);
              });
            });
          })
          .catch(() => setLoading(false));
      })
      .catch(() => setLoading(false));
  };

  return (
    <WithFacebookLogin appId={facebookId} scope="email" emailMandatory loginHandler="bridgekeeper">
      {({ login, serverSideLoginPath }) => (
        <SocialAuthButton type="fb" href={serverSideLoginPath} onSocialClick={e => socialLogin(e, login)} />
      )}
    </WithFacebookLogin>
  );
};

FacebookAuth.propTypes = {
  facebookId: number,
  setMember: func.isRequired,
  setLoading: func.isRequired,
  closePopup: func,
  setUserPlans: func
};

export default FacebookAuth;
